import React from "react";
import { Navigate } from "react-router-dom";

const SubscriptionList = React.lazy(() => import('src/pages/subscription_management/SubscriptionList'));
const ViewSubscription = React.lazy(() => import('src/pages/subscription_management/ViewSubscription'));
const SubscriptionPlanList = React.lazy(() => import('src/pages/subscription_management/SubscriptionPlanList'));

// The subscriptions list is the group's Overview now. The old revenue Overview
// page is retired, so its URL redirects here rather than 404ing for anyone
// holding a bookmark.
const RedirectToOverview = () => <Navigate to="/dashboard/subscription-management/subscriptions" replace />;

// Boost packages moved to the Listing Boost group; the old URL follows it.
const RedirectToBoostPackages = () => <Navigate to="/dashboard/listing-boost/boost-packages" replace />;

const routes = [
    { path: '/dashboard/subscription-management', name: 'Subscription', element: RedirectToOverview },
    { path: '/dashboard/subscription-management/overview', name: 'Overview', element: RedirectToOverview },
    { path: '/dashboard/subscription-management/subscriptions/:param', withParam: true, exact: true, name: 'Subscription Details', element: ViewSubscription },
    { path: '/dashboard/subscription-management/subscriptions', name: 'Overview', element: SubscriptionList },
    { path: '/dashboard/subscription-management/subscription-plan', name: 'Subscription Plan', element: SubscriptionPlanList },
    { path: '/dashboard/subscription-management/boost-packages', name: 'Boost Packages', element: RedirectToBoostPackages },
];

export default routes;
